import http from '@/app/services/httpServices';
import URL_UTILITY from '@/app/utility/url.utility';

const getVendorBankUpdateData = (context, payload) => {
  return http.getApi(
    URL_UTILITY.getVendorBankUpdateUrl +
      '/party-bank-update-grid?',
      payload
  );
};

const getVendorBankUpdateDataById = (context, payload) => {
  return http.getApi(
    URL_UTILITY.getVendorBankUpdateUrl +
      `/party-on-boarding/${payload.partyReqUpdateId}`  );
};
const getVendorContactUpdateData = (context, payload) => {
  return http.getApi(
    URL_UTILITY.getVendorBankUpdateUrl +
      '/party-contact-update-grid',
      payload
  );
};
const getVendorContactUpdateDataById = (context, payload) => {
  return http.getApi(
    URL_UTILITY.getVendorBankUpdateUrl +
      `/party-contact-update-grid/${payload.partyReqid}`  );
};

export default {
  getVendorBankUpdateData,
  getVendorBankUpdateDataById,
  getVendorContactUpdateData,
  getVendorContactUpdateDataById
};
